
module dgLogger {
    declare var JL: any;
    angular.module('dgLogger', ['dgUtils'])
        .run(['$rootScope', 'dgGuid',
            ($rootScope: ng.IRootScopeService, dgGuid: dgUtils.DgGuid) => {
                $rootScope.$on('$stateChangeSuccess', (event, toState) => {
                    JL.setOptions({
                        'requestId': dgGuid.generateGUID()
                    });
                });
            }]);
        
}